// given a string included spaces and capital letters, replace the capital letters with small letters and replace spaces with underscore
export const EncodeStringToUrl = str => encodeURI(
  str
    .toLowerCase()
    .replace(/\s/g, '_')
    .replace('%', '')
)
